export default "__VITE_ASSET__CzN2MFK1__"